/**
 * Variant Option Visibility
 *
 * Hides disabled/crossed-out variant option values and entire option groups
 * when all their values are disabled.  Auto-selects the first available
 * option when the current selection is hidden.
 *
 * Runs immediately (no delays) to avoid visual blink.
 */

(function () {
  'use strict';

  // Guard to prevent infinite loops from programmatic change events
  var _guard = false;

  /* ── CSS injection ───────────────────────────────────────────────── */
  var STYLE_ID = 'variant-vis-css';
  if (!document.getElementById(STYLE_ID)) {
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      'variant-selects .product-form__input input[type="radio"].disabled,' +
      'variant-selects .product-form__input input[type="radio"].disabled + label,' +
      'variant-selects .product-form__input input[type="radio"].visually-disabled,' +
      'variant-selects .product-form__input input[type="radio"].visually-disabled + label,' +
      'variant-selects .product-form__input input[type="radio"][data-value-hidden="true"],' +
      'variant-selects .product-form__input input[type="radio"][data-value-hidden="true"] + label,' +
      'variant-selects .product-form__input select option:disabled,' +
      'variant-selects .product-form__input select option[hidden],' +
      'variant-selects .product-form__input select option[data-value-hidden="true"]' +
      '{display:none!important}';
    document.head.appendChild(s);
  }

  /* ── helpers ──────────────────────────────────────────────────────── */

  function getOptionGroups(vs) {
    var all = vs.querySelectorAll('.product-form__input');
    var result = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].querySelector(
        'input[name="family_wood"],input[name="family_chairtype"],' +
        'select[name="family_wood"],select[name="family_chairtype"]'
      )) {
        result.push(all[i]);
      }
    }
    return result;
  }

  function isRadioHidden(radio) {
    return radio.classList.contains('disabled') ||
           radio.classList.contains('visually-disabled') ||
           radio.getAttribute('data-value-hidden') === 'true';
  }

  function isOptionHidden(opt) {
    return opt.disabled || opt.getAttribute('data-value-hidden') === 'true';
  }

  /* ── core ─────────────────────────────────────────────────────────── */

  function applyRules(vs) {
    if (!vs) return;
    var groups = getOptionGroups(vs);
    if (groups.length <= 1) return;

    for (var i = 1; i < groups.length; i++) {
      processGroup(groups[i]);
    }
  }

  function processGroup(group) {
    var totalCount = 0;
    var hiddenCount = 0;
    var checkedIsHidden = false;
    var firstVisible = null;

    // ── radios ──
    var radios = group.querySelectorAll('input[type="radio"]');
    for (var j = 0; j < radios.length; j++) {
      var r = radios[j];
      totalCount++;
      if (isRadioHidden(r)) {
        hiddenCount++;
        if (r.checked) checkedIsHidden = true;
      } else {
        if (!firstVisible) firstVisible = r;
      }
    }

    // ── select ──
    var sel = group.querySelector('select');
    var firstVisibleOpt = null;
    var selIsHidden = false;
    if (sel) {
      for (var k = 0; k < sel.options.length; k++) {
        var opt = sel.options[k];
        totalCount++;
        if (isOptionHidden(opt)) {
          hiddenCount++;
          opt.hidden = true;
          if (opt.selected) selIsHidden = true;
        } else {
          opt.hidden = false;
          if (!firstVisibleOpt) firstVisibleOpt = opt;
        }
      }
    }

    // ── upholstery sub-group labels ──
    var subLabels = group.querySelectorAll('.product-form__upholstery-group-label');
    for (var l = 0; l < subLabels.length; l++) {
      var lbl = subLabels[l];
      var sib = lbl.nextElementSibling;
      var hasVis = false;
      while (sib) {
        if (sib.classList.contains('product-form__upholstery-group-label')) break;
        if (sib.tagName === 'INPUT' && sib.type === 'radio' && !isRadioHidden(sib)) {
          hasVis = true;
          break;
        }
        sib = sib.nextElementSibling;
      }
      lbl.style.display = hasVis ? '' : 'none';
    }

    // ── hide/show entire group ──
    if (totalCount > 0 && hiddenCount === totalCount) {
      group.style.display = 'none';
    } else {
      group.style.removeProperty('display');
    }

    // ── auto-select first visible radio ──
    // Only when the current selection is hidden/disabled (same as pre-hidden-metafield behavior).
    if (checkedIsHidden && firstVisible && !_guard) {
      firstVisible.checked = true;
      // Update display text
      var fs = firstVisible.closest('.product-form__input');
      if (fs) {
        var sv = fs.querySelector('[data-selected-swatch-value]');
        if (sv) sv.textContent = firstVisible.value;
        var sv2 = fs.querySelector('[data-selected-value]');
        if (sv2) sv2.textContent = firstVisible.value;
      }
      _guard = true;
      firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { _guard = false; }, 300);
    }

    // ── auto-select first visible option in dropdown ──
    if (selIsHidden && firstVisibleOpt && sel && !_guard) {
      sel.value = firstVisibleOpt.value;
      firstVisibleOpt.selected = true;
      _guard = true;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { _guard = false; }, 300);
    }
  }

  /* ── wiring ──────────────────────────────────────────────────────── */

  function applyAll() {
    var all = document.querySelectorAll('variant-selects');
    for (var i = 0; i < all.length; i++) applyRules(all[i]);
  }

  // Observe each product-info for DOM swaps (runs immediately, no delay)
  function observe() {
    var pis = document.querySelectorAll('product-info');
    for (var i = 0; i < pis.length; i++) {
      var pi = pis[i];
      if (pi._vvo) continue;
      pi._vvo = new MutationObserver(function () {
        if (!_guard) applyAll();
      });
      pi._vvo.observe(pi, { childList: true, subtree: true });
    }
  }

  function init() {
    applyAll();
    observe();
  }

  // Run as soon as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Hook into FoxTheme pub/sub for variant changes
  function sub() {
    if (typeof FoxTheme === 'undefined' || !FoxTheme.pubsub || !FoxTheme.pubsub.subscribe) return false;

    FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
      function (p) {
        var vs = document.querySelector('#variant-selects-' + p.data.sectionId);
        if (vs) applyRules(vs);
        observe();
      }
    );

    FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
      function () { observe(); }
    );

    return true;
  }

  if (!sub()) {
    var n = 0, iv = setInterval(function () { n++; if (sub() || n > 50) clearInterval(iv); }, 100);
  }
})();
